import * as React from 'react';
import { Box } from '../../designSystem/components/box';
import { CustomBadgeVolunteerRegistrationFragment } from '../../generated/types';
import { isNonEmptyString } from '../../util/string';
import { BarcodeTypes, getBarcodeHref } from '../../util/url';
import { DocumentImageElement } from '../../vo/documentBuilder';

const getSrc = (source: string, vr: CustomBadgeVolunteerRegistrationFragment) => {
    if (source === '{user.picture}') {
        return vr.userInfo.fields?.picture?.url || '';
    } else if (source === '{user.qrcode}') {
        const ticketId = vr.weezeventParticipantInfo?.idBarcode ?? vr.ticketId;

        return getBarcodeHref(ticketId, { height: 100, width: 100 });
    } else if (source === '{user.code39}') {
        const ticketId = vr.weezeventParticipantInfo?.idBarcode ?? vr.ticketId;

        return getBarcodeHref(ticketId, {
            barcodeType: BarcodeTypes.Code39,
            height: 28,
            width: 234
        });
    } else {
        return source;
    }
};

interface IUserCustomDocumentImageProps {
    element: DocumentImageElement;
    vr: CustomBadgeVolunteerRegistrationFragment;
}

export const UserCustomDocumentImage = (props: IUserCustomDocumentImageProps) => {
    const img =
        isNonEmptyString(props.element.source) &&
        isNonEmptyString(getSrc(props.element.source, props.vr)) ? (
            <img height="100%" src={getSrc(props.element.source, props.vr)} width="100%" />
        ) : null;

    return (
        <Box
            css={{
                border:
                    props.element.borderSize > 0
                        ? `${props.element.borderSize}px solid ${props.element.borderColor}`
                        : '',
                borderRadius:
                    props.element.borderRadius > 0 ? `${props.element.borderRadius}px` : '0',
                left: `${props.element.left}px`,
                overflow: 'hidden',
                paddingBottom: `${props.element.py || 0}px`,
                paddingLeft: `${props.element.px || 0}px`,
                paddingRight: `${props.element.px || 0}px`,
                paddingTop: `${props.element.py || 0}px`,
                position: props.element.inContainer ? 'static' : 'absolute',
                top: `${props.element.top}px`,
                transform: props.element.hasRotate
                    ? `rotate(${props.element.rotateDegree}deg)`
                    : undefined,
                transformOrigin: props.element.hasRotate ? 'top left' : undefined,
                zIndex: props.element.zIndex
            }}
            height={props.element.height}
            width={props.element.width}
        >
            {isNonEmptyString(props.element.link) ? (
                <a href={props.element.link} rel="noreferrer" target="_blank">
                    {img}
                </a>
            ) : (
                img
            )}
        </Box>
    );
};
